import React, { Fragment } from 'react';
import { Table, Button, Menu, Divider, Dropdown, Icon, Modal, Badge, message } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { formatTimestamp } from 'utils/utils.js';
import { chargeItemStatusMapArr } from 'utils/enum/state-enum.js';
import { stringify } from 'qs';
import Address from 'components_business/Address/Index.js';
import _cloneDeep from 'lodash/cloneDeep';
import styles from './Table.less';

@connect(({ operationChargeItem, loading }) => ({
  loading:
    loading.effects['operationChargeItem/fetchDataSource'] ||
    loading.effects['operationChargeItem/close'] ||
    loading.effects['operationChargeItem/call'],
  dataSource: operationChargeItem.dataSource,
  pagination: operationChargeItem.pagination,
}))
export default class Record extends React.Component {
  constructor(props) {
    super(props);

    this.curGoods = ''; // 当前处理的商品信息
    this.handleOk = this.handleOk.bind(this);
  }

  static getAddressDetail(userList) {
    const resultList = [];

    userList.forEach(item => {
      const parentIdLength = item.parentId.length;
      const gradeIdIndex = parentIdLength >= 2 ? parentIdLength - 2 : parentIdLength - 1;
      const orgStructIdIndex = parentIdLength - 1;

      resultList.push({
        userId: item.id,
        userName: item.name,
        gradeName: item.lastDepartName,
        gradeId: item.parentId[gradeIdIndex], // 用户上级部门（所在年级）id
        className: item.curDepartName,
        orgStructId: item.parentId[orgStructIdIndex],
        groupType: item.groupType,
      });
    });

    return resultList;
  }

  handleOk({ userList: _userList }) {
    const userList = Record.getAddressDetail(_cloneDeep(_userList));
    const userIdList = _cloneDeep(userList).map(item => item.userId);

    const { dispatch } = this.props;

    // 判断用户有没有在当前项目创建订单
    dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/putExistorder',
      orderGroupId: this.curGoods.id,
      userIds: userIdList,
    }).then(ret => {
      const { result, invalidUserIds } = ret;

      if (!result) {
        const invalidUserName = [];
        userList.forEach(userItem => {
          const _result = invalidUserIds.some(id => id === userItem.userId);

          if (_result) {
            invalidUserName.push(userItem.userName);
          }
        });
        message.error(`以下用户已在当前项目创建订单：${invalidUserName.join(',')}`);
        return Promise.reject();
      }

      // 补发操作
      dispatch({
        type: 'operationChargeItemPublishChargeItemSteps/putReissue',
        id: this.curGoods.id,
        users: userList,
      }).then(() => {
        dispatch({ type: 'operationChargeItem/toggleRefreshFlag' });
      });
    });
  }

  handleQueryDetail = (id, orderGroupId) => {
    this.props.dispatch({
      type: 'GoodsDetailModal/fetchGoodsDetailOrderGroup',
      id,
      orderGroupId,
    });
  };

  // 发布收费
  handleAdd = () => {
    this.props.dispatch(routerRedux.push(`/operation/charge-item/publish`));
  };

  // 查看支付二维码
  handleQueryQRCode = rowData => {
    this.props.dispatch({
      type: 'CheckQRCode/fetchPayInfo',
      id: rowData.id,
      status: rowData.status,
    });
  };

  // 缴费统计
  handleStatistics = rowData => {
    const params = {
      chargeItemId: rowData.id,
      title: rowData.title,
      orgName: rowData.orgName,
    };
    const { dispatch } = this.props;
    if (rowData.mode === '扫码收费') {
      params.type = 'scan';
    } else {
      params.type = 'notification';
    }

    dispatch(routerRedux.push(`/operation/charge-item/statistics/list?${stringify(params)}`));
  };

  // 补发
  handleSupplementary = rowData => {
    this.curGoods = rowData;

    this.props.dispatch({
      type: 'AddressBook/saveOrgId',
      orgId: rowData.orgId,
    });

    this.props.dispatch({
      type: 'AddressBook/setChargeTarget',
      payload: {
        visible: true,
        addressBook: [],
        selected: [],
        defaultCheckedKey: [],
        schoolName: '',
        exceptNodes: {},
      },
    });
  };

  // 截止
  handleClose = rowData => {
    Modal.confirm({
      title: '中止后，用户无法进行缴费，确认中止？',
      onOk: () => {
        const { dispatch } = this.props;

        dispatch({
          type: 'operationChargeItem/close',
          id: rowData.id,
        }).then(() => {
          dispatch({ type: 'operationChargeItem/toggleRefreshFlag' });
        });
      },
    });
  };

  // 延期
  handleDelay = rowData => {
    this.props.dispatch({
      type: 'operationChargeItem/toggleModalVisibility',
      modal: {
        showDelay: true,
        rowData,
      },
    });
  };

  // 催缴
  handleCall = rowData => {
    Modal.confirm({
      title: '确认后，将对所有未收费用户进行催缴，确认继续？',
      onOk: () => {
        const { dispatch } = this.props;

        dispatch({
          type: 'operationChargeItem/call',
          id: rowData.id,
        }).then(() => {
          dispatch({ type: 'operationChargeItem/toggleRefreshFlag' });
        });
      },
    });
  };

  handleTableChange(pagination, filters, sorter) {
    this.props.dispatch({
      type: 'operationChargeItem/savePagination',
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    if (this.props.onChange) {
      this.props.onChange(pagination, filters, sorter);
    }
  }

  render() {
    const columns = [
      {
        title: '项目号',
        dataIndex: 'id',
      },
      {
        title: '学校名称',
        dataIndex: 'orgName',
      },
      {
        title: '收费项目名称',
        dataIndex: 'title',
      },
      {
        title: '商品名称',
        dataIndex: 'commodities',
        render: (val, rowData) => {
          const ret = [];
          val.forEach(commodity => {
            ret.push(
              <a
                key={commodity.commodityId}
                onClick={this.handleQueryDetail.bind(this, commodity.commodityId, rowData.id)}
              >
                {`【${commodity.name}】`}
              </a>
            );
          });

          return ret;
        },
      },
      {
        title: '收费方式',
        dataIndex: 'mode',
      },
      {
        title: '项目状态',
        dataIndex: 'status',
        render: val => {
          const status = chargeItemStatusMapArr.find(q => q.value === val);
          return <Badge status={status.badge} text={status.value} />;
        },
      },
      {
        title: '总人数',
        dataIndex: 'total',
        render: (val, rowData) => {
          if (rowData.mode === '扫码收费') {
            return '-';
          }

          return val;
        },
      },
      {
        title: '已交人数',
        dataIndex: 'paid',
      },
      {
        title: '现金／转账人数',
        dataIndex: 'offline',
        render: (val, rowData) => {
          if (rowData.mode === '扫码收费') {
            return '-';
          }

          return val;
        },
      },
      {
        title: '不参与人数',
        dataIndex: 'cancel',
      },
      {
        title: '未交人数',
        dataIndex: 'unpaid',
        render: (val, rowData) => {
          if (rowData.mode === '扫码收费') {
            return '-';
          }

          return val;
        },
      },
      {
        title: '发布日期',
        dataIndex: 'gmtBegin',
        render: val => formatTimestamp(val),
      },
      {
        title: '截止日期',
        dataIndex: 'gmtEnd',
        render: val => formatTimestamp(val),
      },
      {
        title: '发布人',
        dataIndex: 'creator',
      },
      {
        title: '操作',
        render: rowData => {
          const menu = (
            <Menu>
              {rowData.mode === '通知收费' && (
                <Menu.Item onClick={this.handleSupplementary.bind(this, rowData)}>补发</Menu.Item>
              )}
              <Menu.Item onClick={this.handleClose.bind(this, rowData)}>截止</Menu.Item>
              <Menu.Item onClick={this.handleDelay.bind(this, rowData)}>延期</Menu.Item>
              {rowData.mode === '通知收费' && (
                <Menu.Item onClick={this.handleCall.bind(this, rowData)}>催缴</Menu.Item>
              )}
            </Menu>
          );

          return (
            <Fragment>
              <a onClick={this.handleQueryQRCode.bind(this, rowData)}>查看支付二维码</a>
              <Divider type="vertical" />
              <a onClick={this.handleStatistics.bind(this, rowData)}>缴费统计</a>
              {rowData.allowModify && (
                <Fragment>
                  <Divider type="vertical" />
                  <Dropdown overlay={menu}>
                    <a>
                      更多<Icon type="down" />
                    </a>
                  </Dropdown>{' '}
                </Fragment>
              )}
            </Fragment>
          );
        },
      },
    ];

    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      current: this.props.pagination.current,
      total: this.props.pagination.total,
    };

    return (
      <div className={styles.root}>
        <div className="table-operation-buttons-wraps">
          <Button type="primary" icon="plus" onClick={this.handleAdd.bind(this)}>
            发布收费
          </Button>
        </div>
        <Table
          loading={this.props.loading}
          rowKey="id"
          dataSource={this.props.dataSource}
          columns={columns}
          pagination={pagination}
          onChange={this.handleTableChange.bind(this)}
        />
        <Address renderContent="table" onOk={this.handleOk} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/Table.js